import React from 'react';

// Three stacked pills read as a pile; the droplet is the app's original mark
const PATHS = {
    pee: 'M12 2.5c3.4 4.6 7 8.6 7 12.5a7 7 0 1 1-14 0c0-3.9 3.6-7.9 7-12.5z',
    poo: 'M6.5 15h11a3 3 0 0 1 0 6h-11a3 3 0 0 1 0-6zM8.7 10h6.6a2.7 2.7 0 0 1 0 5.4H8.7a2.7 2.7 0 0 1 0-5.4zM11.4 5.4h1.2a2.6 2.6 0 0 1 0 5.2h-1.2a2.6 2.6 0 0 1 0-5.2z',
};

const EntryIcon = ({type, className}) => (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
        <path d={PATHS[type] || PATHS.pee} fill="currentColor"/>
    </svg>
);

export default EntryIcon;
